<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "app"
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
}

* {
  box-sizing: border-box;
}

.main-block {
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.my-table {
  height: calc(100vh - 118px) !important;
}

.el-table__body,
.el-table__header {
  table-layout: auto;
}

.my-btn {
  width: 100%;
}

.my-btn-panel {
  margin-left: 10px;
  margin-right: 10px;
}

.my-label {
  margin-bottom: 10px;
  margin-top: 10px;
  display: block;
}

.el-menu {
  border-radius: 0px;
}

/* ---- inseminations tab --*/

.send-insemination-block {
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.btn {
  margin-top: 10px;
  margin-bottom: 10px;
}

.wirzch-login-iframe {
  display: none;
}

.ertus-switch {
  margin-top: 10px;
}

.notransition {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}

.el-table--striped .el-table__body tr.current-row:nth-child(2n) td,
.el-table__body tr.current-row > td {
  background: #2598f5 !important;
}

.estrus-row-mark {
  background-color: #fda4a4 !important;
}
</style>
